import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../helpers';

// create slice

const name = 'factures';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const reducers = createReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const factureActions = { ...slice.actions, ...extraActions };
export const facturesReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        factures: {},
        facturesLoad:false,
        error: null,
        lastInsertId:0
    }
}

function createReducers() {
  return{
    deleteLastInsertId,
  }
  function deleteLastInsertId(state){
    state.lastInsertId= 0;
  }
}

function createExtraActions() {

    const baseUrl = `${import.meta.env.VITE_API_URL}/api/factures/`;

    return {
      getAll: getAll(),
      postFacture: postFacture()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async (user) => fetchWrapper.get(baseUrl+user,'',user)
        );
    }
    function postFacture() {
      return createAsyncThunk(
          `${name}/postFacture`,
          async ({ adherent, description, montant }) => fetchWrapper.post(baseUrl,{ adherent, description, montant },adherent)
      );
    }
}

function createExtraReducers() {
    return (builder) => {
        builder
            .addCase(extraActions.getAll.pending, (state, action) => {
                state.error = action.error;
                state.facturesLoad = false;
            })
            .addCase(extraActions.getAll.fulfilled, (state, action) => {
                state.factures = action.payload;
                state.facturesLoad = true;
            })
            .addCase(extraActions.getAll.rejected, (state, action) => {
                state.error = action.error;
            })
            .addCase(extraActions.postFacture.pending, (state, action) => {
                state.error = action.error;
            })
            .addCase(extraActions.postFacture.fulfilled, (state, action) => {
                state.lastInsertId = action.payload.id;
            })
            .addCase(extraActions.postFacture.rejected, (state, action) => {
                state.error = action.error;
            });
    };
}
